import NextLink from 'next/link';

import { Icon, Image } from '@frontendmentorio/design-system-v2';

const LINKS = {
  bluesky: {
    icon: 'bluesky',
    name: 'Bluesky',
  },
  codePen: {
    icon: 'codepen',
    name: 'CodePen',
  },
  devTo: {
    icon: 'dev',
    name: 'Dev.to',
  },
  freeCodeCamp: {
    icon: 'free-code-camp',
    name: 'freeCodeCamp',
  },
  gitHub: {
    icon: 'github',
    name: 'GitHub',
  },
  gitLab: {
    icon: 'gitlab',
    name: 'GitLab',
  },
  hashnode: {
    icon: 'hashnode',
    name: 'Hashnode',
  },
  linkedIn: {
    icon: 'linkedin',
    name: 'LinkedIn',
  },
  mastodon: {
    icon: 'mastodon',
    name: 'Mastodon',
  },
  medium: {
    icon: 'medium',
    name: 'Medium',
  },
  stackOverflow: {
    icon: 'stack-overflow',
    name: 'StackOverflow',
  },
  twitch: {
    icon: 'twitch',
    name: 'Twitch',
  },
  twitter: {
    icon: 'x-twitter',
    name: 'X',
  },
  youTube: {
    icon: 'youtube',
    name: 'YouTube',
  },
};

export default function SocialLinks({ user }) {
  let links = [];

  Object.entries(user.links).map(([name, href]) =>
    links.push({
      href,
      name,
      ...LINKS[name],
    })
  );

  links = links.filter(
    (link) => link.name !== 'website' && link.name !== 'codewars'
  );

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-2 items-center justify-center text-cyan-500 text-xl tablet:justify-start">
      {user.links.website && (
        <NextLink
          aria-label={`Visit ${user.displayName}'s website`}
          href={user.links.website}
        >
          <Icon name="globe" style="solid" />
        </NextLink>
      )}

      {links.map((link) => (
        <NextLink
          aria-label={`Visit ${user.displayName}'s ${link.name} page`}
          href={link.href}
          key={link.name}
        >
          <Icon name={link.icon} style="brands" />
        </NextLink>
      ))}

      {user.links.codewars && (
        <NextLink
          aria-label={`Visit ${user.displayName}'s Codewars profile`}
          href={user.links.codewars}
        >
          <Image
            alt=""
            height={24}
            src="/static/images/codewars.svg"
            width={24}
          />
        </NextLink>
      )}
    </div>
  );
}
